import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'

const HistoryBankWithdrawal = () => {
    const { id } = useParams();

    const [detailData, setDetailData] = useState(null);
    const [error, setError] = useState(null);

    const BASE_URL = "http://localhost/hijrah-backend";
    const PATH_DATA_TRANSACTION = "/api/erpppsu/cash-bank/withdrawal";

    const fetchData = async (url) => {
        try {
            const response = await axios.get(url);
            return response.data;
        } catch (err) {
            setError("Gagal memuat data. Silakan coba lagi.");
            console.error(err);
            return null;
        }
    };

    useEffect(() => {
        if (id) {
            fetchData(`${BASE_URL}${PATH_DATA_TRANSACTION}/detail?id=${id}`).then((data) => {
                setDetailData(data)
            });
        }
    }, [id]);

    return (
        <div className="mx-auto p-4">
            <div className='flex items-center justify-between p-5'>
                <div className='flex flex-col'>
                    <label className='font-semibold text-gray-500'>Transaksi</label>
                    <h2 className="text-2xl font-bold mb-4">
                        Bank Withdrawal {detailData?.no_transaction}
                    </h2>
                </div>

                <div className='flex items-center'>
                </div>
            </div>

            <div className="container m-auto border-2 ">
                <div className='flex flex-row justify-between mb-6 bg-[#E0F7FF] p-5'>
                    <div className='flex flex-row'>
                        <div className="font-bold">
                            <p>Bayar Dari</p>
                        </div>
                        <div className="px-2">
                            <p>{detailData?.bank_name}</p>
                        </div>
                    </div>
                    <div className='flex flex-row'>
                        <div className="font-bold">
                            <p>Total Amount</p>
                        </div>
                        <div className="px-2">
                            <p>Rp {parseFloat(detailData?.amount).toLocaleString("id-ID")}</p>
                        </div>
                    </div>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3xl:grid-cols-4 gap-6 mb-6 p-5">
                    <div className='flex flex-row mx-2'>
                        <div className="basis-1/3 font-bold">
                            <p className='text-sm'>Penerima</p>
                        </div>
                        <div className="px-2">
                            <p className='text-sm'>{detailData?.contact_name}</p>
                        </div>
                    </div>
                    <div className='flex flex-row mx-2'>
                        <div className="basis-1/3 font-bold">
                            <p className='text-sm'>Tgl Transaksi</p>
                        </div>
                        <div className="px-2">
                            <p className='text-sm'>{detailData?.date}</p>
                        </div>
                    </div>
                    <div className='flex flex-row mx-2'>
                        <div className="basis-1/3 font-bold">
                            <p className='text-sm'>No Transaksi</p>
                        </div>
                        <div className="basis-1/3">
                            <p className='text-sm'>{detailData?.no_transaction}</p>
                        </div>
                    </div>
                    <div className='flex flex-row mx-2'>
                        <div className="basis-1/3 font-bold">
                            <p className='text-sm'>Tag</p>
                        </div>
                        <div className="">
                            <p className='text-sm'>{detailData?.tags}</p>
                        </div>
                    </div>
                </div>

                <table className="w-full text-left">
                    <thead className='bg-[#E0F7FF]'>
                        <tr>
                            <th className="p-2">Akun</th>
                            <th className="p-2">Deskripsi</th>
                            <th className="p-2">Jumlah</th>
                        </tr>
                    </thead>
                    <tbody>
                        {detailData?.transaction?.map((data, index) => (
                            <tr
                                key={index}
                                className="hover:bg-gray-50 transition-colors"
                            >
                                <td className="p-2">{data?.account_name}</td>
                                <td className="p-2">{data?.title}</td>
                                <td className="p-2 text-right">Rp {parseFloat(data?.debit).toLocaleString("id-ID")}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>

                {/* Summary Section */}
                <div className="flex flex-col items-end mt-6 p-5">
                    <p className="text-right">
                        <span className="font-semibold">Subtotal:</span> Rp{" "}
                        {parseFloat(detailData?.subtotal_amount).toLocaleString("id-ID")}
                    </p>
                    <p className="text-right">
                        <span className="font-semibold">Pajak:</span> Rp{" "}
                        {parseFloat(detailData?.tax_amount).toLocaleString("id-ID")}
                    </p>
                    <h3 className="text-right text-lg font-bold mt-2">
                        Total: Rp {parseFloat(detailData?.amount).toLocaleString("id-ID")}
                    </h3>
                    <h3 className="text-right text-lg font-bold text-blue-600 mt-2">
                        Sisa Tagihan: Rp {parseFloat(detailData?.amount).toLocaleString("id-ID")}
                    </h3>
                </div>
            </div>
        </div >
    )
}

export default HistoryBankWithdrawal;
